module.exports = __webpack_public_path__ + "static/media/01-overview-portal.5d6ab3a9.png";